import HuellaLoading from "./huella-loading.gif";
import GovoLoading from "./govo_loading.gif";
import EFirmaImage from "./efirma.png";
import FirmaAvanzadaImage from "./avanzada.png";
import FirmaAutografaImage from "./autografa.png";
import HistoricPlan from "./historico_plan.png";
import HibouGif from "./acerca_de_hibou.gif";
import TypeESignature from "./tip_efirma.jpg";
import TipSignature from "./imagen_tips.png"
import Background from "./image2.png"

export {
  HuellaLoading,
  EFirmaImage,
  FirmaAvanzadaImage,
  FirmaAutografaImage,
  HistoricPlan,
  GovoLoading,
  HibouGif,
  TypeESignature,
  TipSignature,
  Background
};
